import React from "react";
import { Link, NavLink, useNavigate } from "react-router-dom";
import { LogOut, LayoutDashboard, ClipboardList, PlusCircle, FolderTree, Ruler, Scissors, Settings as SettingsIcon } from "lucide-react";
import { useAuth } from "../../context/AuthContext";
import { useI18n } from "../../i18n/I18nContext";

export default function CoutureLayout({ children }) {
    const { logout, user } = useAuth();
    const { t } = useI18n();
    const navigate = useNavigate();

    const handleLogout = async () => {
        await logout();
        navigate("/couturier/login");
    };

    const linkCls = ({ isActive }) =>
        `flex items-center gap-3 px-4 py-3 text-sm transition-colors ${
            isActive ? "bg-brand-gold text-white" : "text-white/80 hover:bg-white/5"
        }`;

    return (
        <div className="min-h-screen bg-brand-paper flex">
            <aside className="hidden md:flex w-64 bg-brand-navy text-white flex-col" data-testid="couture-sidebar">
                <div className="px-5 py-6 border-b border-white/10 bg-white/5 flex items-center gap-3">
                    <div className="w-9 h-9 bg-brand-gold flex items-center justify-center shrink-0">
                        <Scissors className="w-5 h-5 text-brand-navy" />
                    </div>
                    <div>
                        <div className="font-display text-base leading-tight">GAB'S SERVICES</div>
                        <div className="text-[0.6rem] tracking-[0.22em] uppercase text-brand-gold">{t("couture.space")}</div>
                    </div>
                </div>
                <nav className="flex-1 p-3 space-y-1">
                    <NavLink to="/couturier" end className={linkCls} data-testid="couture-nav-dashboard">
                        <LayoutDashboard className="w-4 h-4" /> {t("couture.dashboard")}
                    </NavLink>
                    <NavLink to="/couturier/commandes" className={linkCls} data-testid="couture-nav-orders">
                        <ClipboardList className="w-4 h-4" /> {t("couture.orders")}
                    </NavLink>
                    <NavLink to="/couturier/commandes/nouvelle" className={linkCls} data-testid="couture-nav-new">
                        <PlusCircle className="w-4 h-4" /> {t("couture.new_order")}
                    </NavLink>
                    <NavLink to="/couturier/categories" className={linkCls} data-testid="couture-nav-categories">
                        <FolderTree className="w-4 h-4" /> {t("couture.categories")}
                    </NavLink>
                    <NavLink to="/couturier/mesures" className={linkCls} data-testid="couture-nav-measurements">
                        <Ruler className="w-4 h-4" /> {t("couture.measurement_fields")}
                    </NavLink>
                    <NavLink to="/couturier/parametres" className={linkCls} data-testid="couture-nav-settings">
                        <SettingsIcon className="w-4 h-4" /> {t("couture.settings")}
                    </NavLink>
                </nav>
                <div className="p-3 border-t border-white/10">
                    <div className="text-xs text-white/60 px-2 mb-2 truncate">{user?.email}</div>
                    <button
                        onClick={handleLogout}
                        data-testid="couture-logout"
                        className="w-full inline-flex items-center gap-2 px-4 py-2.5 bg-white/10 hover:bg-brand-gold text-white text-[0.72rem] tracking-[0.22em] uppercase font-semibold transition-colors"
                    >
                        <LogOut className="w-4 h-4" /> {t("admin.logout")}
                    </button>
                    <Link to="/" className="block text-center mt-3 text-xs text-white/60 hover:text-brand-gold">
                        ← {t("nav.home")}
                    </Link>
                </div>
            </aside>
            <main className="flex-1 min-w-0">{children}</main>
        </div>
    );
}
